import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../../../api";
import { Numeral } from "../../../../components/Numeral";
import {  INftAsset } from "../../../../interfaces";
import { Utils } from "../../../../utils";

interface NftMyFavoriteCardProps {
  asset: INftAsset,
  projectCode: string,
  ethRate: number | null
}
export const NftMyFavoriteCard = ({asset, ethRate, projectCode}: NftMyFavoriteCardProps) => {
  const navigate = useNavigate();
  const api = useApi(projectCode)
  const [isFavorite, setFavorite] = useState(true)
  return (
    <div key={asset.nftId} className="cards d-flex flex-column mx-3 mb-4 w-100" style={{ height: '360px', maxWidth: '360px' }}>
      <div className="d-flex justify-content-center align-items-baseline" style={{ height: '220px' }} onClick={() => {
        navigate(`/web/asset/detail/${asset.nftId}`)
      }}>
        <img src={Utils().normalizeImagePath(asset.image, projectCode)} alt={asset.name}
          className="" style={{ height: '100%', maxWidth: 'fit-content' }} />
      </div>
      <div className="p-3 weight-600">{asset.name}</div>
      <div className="d-flex justify-content-between txt-12">
        <div className="d-flex px-3 weight-600">
          <img src={require("../../../../assets/img/nft/Tether-USDT-icon.png")} alt="" width={'22px'} />
          <span className="mx-2">$<Numeral value={asset.sellingPrice} /></span>
        </div>
        <div className="d-flex align-items-center me-3">
          
        </div>
      </div>
      <div className="d-flex justify-between align-items-center px-3 py-2 txt-12">
        <div className="d-flex align-items-center">
          <img src={require("../../../../assets/img/star/ETH.png")} alt="" style={{ width: '22px', height: '22px' }} />
          { ethRate && <span className="mx-2">ETH <Numeral value={asset.sellingPrice / ethRate} /></span>}
        </div>
        <div className="d-flex align-items-center text-purple-700">
          <span className="material-icons-outlined cursor-pointer" title="收藏" onClick={(e) => {
            e.preventDefault();
            setFavorite(!isFavorite);
            api.updateFavoriteNft(asset.nftId)
          }}>{isFavorite ? 'favorite' : 'favorite_border'}</span>
        </div>
      </div>
    </div>
  )
}